/**
 * Theme constants for consistent colors across the application
 */

export const theme = {
  // Primary accent colors (from CTA button)
  accent: '#D4A574',
  accentHover: '#C49564',
  accentRgba: (opacity: number) => `rgba(212, 165, 116, ${opacity})`,
  
  // Text colors
  textDark: '#2c3e50',
  textGray: '#7f8c8d',
  textLight: '#ffffff',
  
  // Background colors
  background: '#fcf1d9', // Page background
  backgroundLight: '#f8f9fa', // Light gray background
  backgroundWhite: '#ffffff',
  
  // Border colors
  borderLight: '#e0e0e0',
  borderGray: '#ddd',
  
  // Special colors
  whatsappGreen: '#25D366',
  footerDark: '#2c3e50',
  
  // Shadow colors
  shadowBlack: (opacity: number) => `rgba(0, 0, 0, ${opacity})`,
  shadowWhite: (opacity: number) => `rgba(255, 255, 255, ${opacity})`,
} as const;

